import { USER_STATE, REDUCERS } from '../../constants.js';

const initialUserState = {
  reducer_type : REDUCERS.REDUCER_ACTIOS_FROM_SM,
  currentState : USER_STATE.LOGED_OUT,
  prevState: USER_STATE.LOGED_OUT
}



const userState = (state = initialUserState, action) => {
  if(action.type === USER_STATE.CHANGE_STATE){
    if(action.currentState===USER_STATE.WRAPUP){
      if([USER_STATE.CALL_OUT, USER_STATE.DIALOG, USER_STATE.CHATTING,USER_STATE.DIALOG_WHATSAPP,USER_STATE.DIALOG_EMAIL,USER_STATE.OTHER].includes(state.currentState)){
        return { currentState : action.currentState, prevState: state.currentState};
      }
      return state;
    }else{
      return { currentState : action.currentState, prevState: state.currentState};
    }
  }else{
    return state;
  }
}

export default userState;



// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_user_states.js